import { getData_Vehicle } from '@/components/report/service';
import { crudRequest } from '@/services/api';
import { calculateDiff, groupBys, groupBysAggreObject } from '@/utils/columnSearch';
import { computeWeightNotAbs } from '@/utils/query';
import { isArray , orderBy } from 'lodash';
import moment from 'moment';
import { DesSiteDetailQuery } from '../Tables/PlanDepartureTable/Sql';

const params = {};
export default {
  namespace: 'stockweightviewmodalsTest',
  state: {
    modalsVisible: false,
    modalsTitle: '',
    modalsNextSite: '',
    scanSite: '',

    // 产品类型饼图
    productList: [],
    // 是否优势产品
    superiorityProductList: [],
    // 发往目的货量
    desSiteToNextSiteList: [],

    loadExportDataList: [],
    unloadExportDataList: [],
    unloadProductData: [],
    loadProductData: [],
    diffStockData: [],
  },

  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({ type: 'update', payload: { modalsVisible: false } });
    },

    // 在库明细
    *queryInStockDetail({ payload }, { call, put, select }) {
      const { scanSiteCode, nextSiteCode } = payload;
      yield put({ type: 'update', payload: { ...payload } });
      let centerWeightViewTest = yield select(({ centerWeightViewTest }) => {
        return centerWeightViewTest;
      });
      const response = yield call(crudRequest, '/api/route/queryInStockDetail', {
        scanSiteCode,
        nextSiteCode,
        startDate: centerWeightViewTest.dateRange[0]
          ? moment(centerWeightViewTest.dateRange[0])?.format(
            centerWeightViewTest?.defualtDateFormat,
          )
          : undefined,
        endDate: centerWeightViewTest.dateRange[1]
          ? moment(centerWeightViewTest.dateRange[1])?.format(
            centerWeightViewTest?.defualtDateFormat,
          )
          : undefined,
      });
      let productTypeBycalcWeights = response?.data?.productTypeBycalcWeights;
      let productTypeBycalcWeightsKey = Object.keys(productTypeBycalcWeights || []);
      let planProductList = productTypeBycalcWeightsKey?.map(key => ({
        name: key,
        value: computeWeightNotAbs(productTypeBycalcWeights[key]),
      }));

      let superiorityProducts = response?.data?.superiorityProducts;
      let superiorityProductsKeys = Object.keys(superiorityProducts || []);
      let superiorityProductList = superiorityProductsKeys?.map(key => ({
        name: key,
        value: computeWeightNotAbs(productTypeBycalcWeights[key]),
      }));
      const sortedData = orderBy(response?.data?.siteDepartureDetailVos, ['proportion'], ['desc']);

      yield put({
        type: 'update',
        payload: {
          desSiteToNextSiteList: isArray(sortedData)
            ? sortedData
            : [],
          productList: isArray(planProductList) ? planProductList : [],
          superiorityProductList,
          lineChartData: {...response?.data,siteDepartureDetailVos:sortedData},

          // planWeightDetialList: isArray(response?.data?.siteDepartureDetailExportVos)
          //   ? response?.data?.siteDepartureDetailExportVos
          //   : [],
          totalInventory: response?.data?.totalInventory || "",
          timelyInventory: response?.data?.timelyInventory || "",
          // 库存
          stockData: isArray(response?.data?.siteDepartureDetailExportVos)
            ? response?.data?.siteDepartureDetailExportVos
            : [],
          // 卸车导出
          unloadProductData: isArray(response?.data?.repertoryUnloadDetailExportVos)
            ? response?.data?.repertoryUnloadDetailExportVos
            : [],
          // 装车导出
          loadProductData: isArray(response?.data?.repertoryLoadDetailExportVos)
            ? response?.data?.repertoryLoadDetailExportVos
            : [],
        },
      });
    },
  },

  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
